
<template>
  <v-container class="pa-8">
    <v-data-table
      :headers="headers"
      :items="orders"
      class="elevation-1"
      :search="search"
      :loading="loading"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title> Commesse </v-toolbar-title>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            class="mx-5"
            append-icon="mdi-magnify"
            label="Search Order"
            single-line
            hide-details
          ></v-text-field>

          <v-dialog v-model="dialog" max-width="800px">
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                Nuova
              </v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col>
                      <v-text-field
                        label="Codice"
                        type="text"
                        v-model="editedOrder.codiceCommessa"
                        :readonly="formTitle != 'Nuova commessa'"
                      ></v-text-field>
                    </v-col>
                    <v-col>
                      <v-text-field
                        label="Descrizione"
                        type="text"
                        v-model="editedOrder.descrizione"
                        :readonly="false"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                   <v-row>
                    <v-col>
                     <v-menu
          ref="menu1"
          v-model="menu1"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field 
              :value="getFormattedDate(editedOrder.data)"
              label="Date"
              hint="DD/MM/YYYY"
              readonly
              persistent-hint
              prepend-icon="mdi-calendar" 
              v-bind="attrs"
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="editedOrder.data"
            no-title
            @input="menu1 = false"
          ></v-date-picker>
        </v-menu>
                    </v-col>
                    <v-col>
                      <v-combobox
                            v-model="editedOrder.statoCommessa"
                            label="Stato commessa"
                            outlined
                            :items="statiCommesse" 
                          >
                          </v-combobox>
                    </v-col>
                   </v-row>
                  <v-row>
                    <v-col> 
                      <StepCustomerHeadquarter
                        v-bind:updateComponents="updateComponents"
                        ref="StepCustomerHeadquarter"
                        v-bind:eventInfo="evento"
                      ></StepCustomerHeadquarter>
                    </v-col>
                  </v-row>

                </v-container> 
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">
                  Cancel
                </v-btn>
                <v-btn color="blue darken-1" text @click="save"> Save </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="dialogDelete" max-width="600px">
            <v-card>
              <v-card-title class="headline"
                >Sei sicuro di voler rimuovere questa commessa?</v-card-title
              >
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDelete"
                  >Cancel</v-btn
                >
                <v-btn color="blue darken-1" text @click="deleteItemConfirm"
                  >OK</v-btn
                >
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <template v-slot:item.colore="{ item }">
        <div
          class="text-center"
          v-bind:style="{
            'background-color': item.colore,
          }"
        >
          <v-col cols="12" md="3">
            <div class="pa-1 rounded-0"></div>
          </v-col>
          <!-- <span class="white--text">{{ item.colore }}</span> -->
        </div>
      </template>

      <template v-slot:item.actions="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)"> mdi-pencil </v-icon>
        <!-- <v-icon small @click="deleteItem(item)"> mdi-delete </v-icon> -->
        <v-icon small @click="deleteItem(item)" :disabled="item.idRuolo == 1">
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
    <div>
      <!-- <template>
        <v-btn color="error" class="mt-3" :to="{ name: 'dashboard' }">
          Indietro
        </v-btn>
      </template> -->
    </div>
    <v-snackbar v-model="ShowSnackbar" :timeout="5000">
      {{ error }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="error = ''">
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<style>
.table-footer-prepend {
  margin-top: -58px;
  height: 58px;
}
</style>
<script>
import EasyPlanClient from "../../utils/EasyPlanClient"; 
import SessionHelper from "../../utils/SessionHelper";
import StepCustomerHeadquarter from "../FrmNewEvent/Steps/StepCustomerHeadquarter.vue";
import moment from 'moment';
export default {
  components: { StepCustomerHeadquarter ,moment},
  data: () => ({
    dialog: false,
    statiCommesse:StatiCommesse,
    loading: false,
     date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      dateFormatted: moment((new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000))).format('DD/MM/yyyy'),
      menu1: false,
    updateComponents: 1,
    clients: [],
    orders: [],
    userTest: "#689F38FF",
    styleCell: {
      color: "red",
      fontSize: "13px",
    },
    dialogDelete: false,
    passwordIcon: "mdi-lock",
    passwordFieldType: "password",
    search: "",
    error: "",
    evento: {},
    headers: [
      { text: "Codice Commessa", value: "codiceCommessa", width: "90px" },
      { text: "Data", value: "dataFormatted", width: "90px",   },
      { text: "Descrizione", value: "descrizione", width: "200px" },
      { text: "Cliente", value: "DescrizioneCliente", width: "90px" },
      // { text: "Email", value: "email", width: "90px" },
      // { text: "Telefono", value: "telefono", width: "90px" },
       
      { text: "Indirizzo", value: "indirizzoCompleto", width: "200px" },
      { text: "Stato", value: "statoCommessa", width: "70px" },

      { text: "Actions", value: "actions", sortable: false, width: "80px" },
    ],

    editedIndex: -1,
    editedOrder: {
      codiceCommessa: "",
      descrizione: "",
      codiceCliente: "",
      email: "",
      data: moment(new Date()).format("yyyy-MM-DD"),
      telefono: "",
      cittaCantiere: "",
      indirizzoCantiere: "",
      provinciaCantiere: "",
      statoCommessa:StatiCommesse.Aperta,
    },
    cliente: null,
    defaultItem: {
      codiceCommessa: "",
      descrizione: "",
      codiceCliente: "",
      email: "",
      telefono: "",
      cittaCantiere: "",
      indirizzoCantiere: "",
      provinciaCantiere: "",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Nuova commessa" : "Modifica commessa";
    },

    ShowSnackbar: {
      get() {
        return this.error.length > 0;
      },
      set(value) {
        if (!value) this.error = "";
      },
    },
  },

  watch: {
    editedOrder(val, old) {
      this.cliente=val.cliente;
      if(val.statoCommessa<0){
        val.statoCommessa=0;
      }
      this.UpdateComponents();
      //  if (val.idCommessa != old.idCommessa) {
      //   this.cliente = this.clients.find(
      //     (c) => c.idCliente == val.codiceCliente
      //   );
      // }
    },
    cliente(val) {
      console.debug("cliente changed", val);
      this.UpdateComponents();
      if (val != null) {
        this.editOrder.codiceCliente = val.idCliente;
        console.debug(
          "cliente changed veramente",
          this.editOrder.codiceCliente
        );
      }
    },
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
  },
  mounted() {
    this.cliente = null;
    this.loadCustomers(() => {this.loadOrders();});
  },
  created() {
    this.initialize();
  },

  methods: {
    UpdateComponents() {
      this.updateComponents++;
    },
    getFormattedDate(date){
      return moment(date).format("DD/MM/yyyy");  
    },
    loadHeadquarters(customerId, callback = () => {}) {
      console.log("loading headquarters: clear");
      this.sediItems = [];
      this.sedi = [];
      console.log("loading headquarters: getAll");
      EasyPlanClient.Headquarters.GetAll(
        this.$route.params.companyAlias,
        customerId
      )
        .then((res) => {
          console.log("loading headquarters: sedi", this.sedi);
          this.sedi = res.data.data;
          for (let i = 0; i < this.sedi.length; i++) {
            let sede = this.sedi[i];
            this.sedi[i].fullAddress = this.getFullAddress(
              sede.indirizzo,
              sede.citta,
              sede.provincia
            );
            console.info("sede", sede);
            this.sediItems.push(sede.fullAddress);
          }

          console.log("loading headquarters: sediItems", this.sediItems);
          callback(this.sedi);
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },
    customer_change(cust) {
      console.info("customer selected", cust);
      // this.editedOrder.codiceCliente=cust.idCliente;
    },
    resetFormData() {
      this.editedOrder = {
        codiceCommessa: "",
        descrizione: "",
        codiceCliente: "",
        cliente:null,
        statoCommessa: StatiCommesse.Aperta,
        email: "",
        telefono: "",
        cittaCantiere: "",
        indirizzoCantiere: "",
        provinciaCantiere: "",
      };
      this.evento={};
      this.editedIndex = -1;
      this.evento.idCliente=0;
      this.evento.cliente=null;
      this.$refs.StepCustomerHeadquarter.resetFormData();
      this.UpdateComponents();
    },
    loadWorkers() {
      this.loading = true;
      console.log("loading workers...");
      EasyPlanClient.Order.Search(this.$route.params.companyAlias, "")
        .then((res) => {
          this.orders = res.data.data;
          console.log(this.orders);
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    editItem(commessa) {
      console.debug("edit order",commessa);
      this.editedIndex = this.orders.indexOf(commessa);
      this.editedOrder = Object.assign({}, commessa);
        this.evento.descrizione = commessa.descrizione;
          
          this.evento.idCliente = commessa.codiceCliente;
          if(commessa.cliente!=null && commessa.cliente!=undefined){
            this.cliente=commessa.cliente;
          }
          console.info(" this.evento.indirizzoCompleto",  this.evento.indirizzoCompleto);
          this.evento.indirizzoCantiere = commessa.indirizzoCantiere;
          this.evento.cittaCantiere = commessa.cittaCantiere;
          this.evento.capCantiere = commessa.capCantiere;
          this.evento.provinciaCantiere = commessa.provinciaCantiere;
          this.evento.indirizzoCompleto=commessa.indirizzoCompleto;
          console.info(" this.evento.indirizzoCompleto",  this.evento.indirizzoCompleto);
          this.evento.commessa = commessa;
      this.evento.commessa=this.editedOrder;
      this.UpdateComponents();
      // if(this.editedUser.idOperatore!=null){

      //  EasyPlanClient.Resources.Find(this.$route.params.companyAlias,
      // this.editedUser.op
      //  )
      // }
      this.dialog = true;
    },

    deleteItem(item) {
      console.debug("delete", item);
      this.editedIndex = this.orders.indexOf(item);
      this.editedOrder = Object.assign({}, item);
      this.dialogDelete = true;
    },

    deleteItemConfirm() {
      EasyPlanClient.Order.Delete(
        this.$route.params.companyAlias,
        this.editedOrder.idCommessa
      ).then((res) => {
        this.orders.splice(this.editedIndex, 1);
        
        this.closeDelete();
          this.loadOrders();
      });
    },

    close() {
      this.dialog = false;
      this.resetFormData();
    },

    closeDelete() {
      this.dialogDelete = false;

      this.resetFormData();
    },

    insertOrder(order, callback = () => {}) {
      console.debug("insert order", order);
      EasyPlanClient.Order.Insert(
        this.$route.params.companyAlias,
        order  
      )
        .then((res) => {
          console.debug("risposta add order:");
          console.debug(res);
          this.orders.push(res.data.data);
          callback(res.data.data);
          this.loadOrders();
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },
    editOrder(order, callback = () => {}) {
      console.debug("editing order",order);
      console.debug(order);
      EasyPlanClient.Order.Update(this.$route.params.companyAlias, order)
        .then((res) => {
          console.debug("risposta edit order:");
          console.debug(res);
          callback(res.data.data);
          this.loadOrders();
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },

    save() {
      this.editedOrder.codiceCliente=this.evento.idCliente;
      this.cliente=this.clients.find(c=>c.idCliente==this.evento.idCliente);
      if(this.cliente!=null && this.cliente !=undefined){

        this.editedOrder.email=this.cliente.mail;
        this.editedOrder.telefono=this.cliente.telefono;
      }
        this.editedOrder.cittaCantiere=this.evento.cittaCantiere;
        this.editedOrder.indirizzoCantiere=this.evento.indirizzoCantiere;
        this.editedOrder.provinciaCantiere=this.evento.provinciaCantiere;
        this.editedOrder.indirizzoCompleto=this.evento.indirizzoCompleto; 
        console.debug("EDITED ORDER",this.editedOrder);
      if (this.editedIndex > -1) {
        console.debug("edit order");
       this.editOrder(this.editedOrder, (user) => {
        //   this.users = this.users.filter((u) => u.idUtente != user.idUtente);
        //   this.users.push(user);
        //   this.close();
        //   this.editedUser = Object.assign({}, this.defaultItem);
        //   this.editedIndex = -1;
        //   let currentUser = SessionHelper.getCurrentUser();
        //   console.log("this.editedUser", user);
        //   console.log("currentUser", currentUser);
        //   if (this.editedUser.idUtente == user.idUtente) {
        //     console.log("UTENTE CORRENTE", currentUser);
        //     currentUser.colore = user.colore;
        //     SessionHelper.setCurrentUser(currentUser);
        //     this.$emit("currentUserChaged", currentUser);
        //     // user.colore=value;
        //   }
        });
      } else {
        
        console.debug("insert order");
         this.insertOrder(this.editedOrder,()=>{
          });
        
      }
      
         this.close();
    },

    initialize() {
      if (
        localStorage.userToken == undefined ||
        localStorage.userToken == "null"
      ) {
        console.debug("logging off");
        localStorage.userToken = null;

        this.$router.push({
          name: "login",
          params: { companyAlias: this.$route.params.companyAlias },
        });
      }
      
    },

    loadOrders() {
      console.log("loading orders...");
      EasyPlanClient.Order.Search(this.$route.params.companyAlias, "",false)
        .then((res) => {
          this.orders = res.data.data;
          this.orders=this.orders.sort((a,b) =>moment(a.data).isAfter(moment(b.data))?
                                                        -1:
                                                        moment(a.data).isBefore(moment(b.data)?1:0))
          for(let i =0;i<this.orders.length;i++){
            let cliente=this.clients.find(c=>c.idCliente==this.orders[i].codiceCliente)
            if(cliente!=null){

            this.orders[i].dataFormatted=moment(this.orders[i].data).format("DD/MM/yyyy");
            this.orders[i].DescrizioneCliente=cliente.descrizione;
            this.orders[i].cliente=cliente ;
            }

          }
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },
    loadCustomers(callback = () => {}) {
      console.log("loading customers...");
      this.clients = [];
      EasyPlanClient.Customers.GetAll(this.$route.params.companyAlias)
        .then((res) => {
          this.clients = res.data.data;
          callback(this.clients);
        })
        .catch((error) => {
          console.log(error);
          this.error = EasyPlanClient.GetErrorDescription(
            error.response.data.errorCode
          );
          console.error(
            "si è verificato un errore (" +
              error.response.data.errorCode +
              ")" +
              this.error
          );
          console.error(error);
        });
    },
  },
};
var StatiCommesse={Aperta:"Aperta",Chiusa:"Chiusa"}
</script>